// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutTypeRadioGroup-RadioTileGroup_cls1__D6+4X","cls2":"PayoutTypeRadioGroup-RadioTileGroup_cls2__uo+Kr PayoutTypeRadioGroup-RadioTileGroup_cls1__D6+4X"};